export function getCookie(name: string) {
  const cookie:{[key:string]: string} = {};
  document.cookie?.split(';')?.forEach(function (el) {
    const split = el.split('=');
    if (split?.length) {
      cookie[split[0].trim()] = split.slice(1)?.join('=');
    }
  });
  return cookie[name] ?? null;
}
export function setCookie(
  name = '',
  value = '',
  { days = 365, domain = null, path = '/' }: { days?: number; domain?: string | null; path?: string } = {},
) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
    if (domain) {
      domain = `domain=${domain};path=${path}`;
    } else {
      domain = `path=${path}`;
    }
  }
  document.cookie = name + '=' + (value || '') + expires + '; ' + domain;
}

export function eraseCookie(name = '', { domain = null, path = '/' }: { domain?: string | null; path?: string } = {}) {
  if (domain) {
    domain = `domain=${domain};path=${path}`;
  } else {
    domain = `path=${path}`;
  }
  document.cookie = name + '=; Max-Age=-99999999;' + domain;
}
